import React, { Component, Suspense, lazy } from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import { Dashboard as DashboardLayout } from '../../layouts'
import hubAPI from '../../services/hubAPI';
import HUBContext from '../../services/HUBContext';
import AlertsResume from '../Alerts/components/alertsResume';
import DashboardPowerbi from './components/dashboardPowerbi';
import { Slide } from '@progress/kendo-react-animation';
import { WidthProvider, Responsive } from "react-grid-layout";

const ResponsiveReactGridLayout = WidthProvider(Responsive);
const Denied = lazy(() => import('../../helpers/accessDenied'));
const NoAuthorization = lazy(() => import('../../helpers/noAuthorization'));
const NoSuccess = lazy(() => import('../../helpers/notSuccess'));
const Loader = lazy(() => import('../../helpers/loader-full'));
const DashboardWidget = lazy(() => import('./components/dashboardWidget'));
const NonCompanyScheduleMessage = lazy(() => import('../Alerts/components/nonCompanyScheduleMessage'))

const styles = theme => ({
	item: { height: '100%' }
});

class Dashboard extends Component {
	static defaultProps = {
		className: "layout",
		preventCollision: true,
		rowHeight: 165,
		cols: { lg: 12, md: 12, sm: 8, xs: 1, xxs: 1 }
	};

	constructor(props) {
		super(props);

		this.state = {
			companyID: localStorage.getItem("companyID"),
			status: null,
			dashboards: [],
			selectedDashboard: null,
			filters: null,
			localFilter: [],
			breadcrumb: [],
			selectedComponentKey: null,
			resizeCallBack: {},

			deniedView: false,
			requestError: false,

			customLayout: false,
			sortedLayout: {},

			showNonCompanyScheduleAlert: false
		}
	}

	//Esto es temporal
	getCompany = (companyID) => {
		if (!companyID) {
			this.setState({ showNonCompanyScheduleAlert: false });
			return;
		}

		this.setState({ status: 'loadingCompany', deniedView: false, requestError: false })
		hubAPI.get(`/api/v1/Company/${companyID}`)
			.then(response => {
				this.setState({ showNonCompanyScheduleAlert: !response.data.enableCompanySchedule });
			})
	}

	componentDidMount() {
		const { match, dashboardKey } = this.props;

		let initBreadcrumb = [
			{ type: 'link', text: this.props.intl.formatMessage({ id: 'fleet', defaultMessage: 'Fleet' }), to: '/dashboard' },
			{ type: 'selector', to: '/dash' }
		];

		if (!!match) {
			if (!!match.params?.componentKey) {
				initBreadcrumb = [
					{ type: 'link', text: this.props.intl.formatMessage({ id: 'fleet', defaultMessage: 'Fleet' }), to: '/dashboard' },
					{ type: 'selector', to: `/dashboard/${match.params.componentKey}` }
				]
			}
		}

		this.setState({
			companyID: this.context.companyID,
			pivotGlobalFilter: this.context.pivotGlobalFilter,
			breadcrumb: !!this.props.breadcrumb ? this.props.breadcrumb : initBreadcrumb,
			selectedComponentKey: !!dashboardKey ? dashboardKey : !!match ? match.params.componentKey : undefined,
			customLayout: this.context.customLayout

		}, () => {
			this.context.setBreadCrumb(this.state.breadcrumb);
			this.context.setRestoreOriginalLayOut(this.restoreOriginalLayOut);
			this.getFilters();
			this.getCompany(this.state.companyID)
		})
	}

	componentDidUpdate() {
		const { match, dashboardKey } = this.props;

		if (this.state.companyID !== this.context.companyID) {
			if (this.context.pivotGlobalFilter === 'dash') { this.context.setPivotGlobalFilter('param') }
			this.setState({ companyID: this.context.companyID }, () => {
				this.getFilters();
				this.getCompany(this.state.companyID)
			})
		}

		if (this.context.pivotGlobalFilter === 'dash') { this.context.setPivotGlobalFilter('param'); this.getFilters() }

		if (this.state.selectedComponentKey !== (!!dashboardKey ? dashboardKey : !!match ? match.params.componentKey : undefined)) {
			this.setState({ selectedComponentKey: match.params.componentKey }, () => {
				this.getDashboards(0, 0, true);
				this.changeDashboard(match.params.componentKey);
			});
		}

		if (this.state.customLayout !== this.context.customLayout) {
			if (!this.context.customLayout)
				this.setState({ customLayout: this.context.customLayout }, () => { this.getDashboards(0, 0, true); });

			else
				this.setState({ customLayout: this.context.customLayout, sortedLayout: {} });
		}
	}

	componentWillMount() {
		this.context.setRestoreOriginalLayOut(null);
	}

	renderWidgets(widgets, removeBorders) {
		const { selectedDashboard, customLayout } = this.state;
		const { dashboardWidgetGroups } = this.context;

		switch (this.state.status) {
			case 'ready':
				if (!!selectedDashboard) {
					return widgets
						.filter(widget => {
							if (dashboardWidgetGroups.length > 0 &&
								dashboardWidgetGroups.indexOf(-1) < 0 &&
								widget.sort > 0 &&
								dashboardWidgetGroups.indexOf(widget.dashboardWidgetGroupID ?? 0) < 0)
								return false;

							return true;
						})
						.map(widget => {

							const setResizeCallBack = callBack => {
								let resizeCallBack = {};
								resizeCallBack[`widget${widget.dashboardWidgetID}`] = callBack;
								this.setState({ resizeCallBack: Object.assign(this.state.resizeCallBack, resizeCallBack) });
							}
							return (
								<div key={widget.dashboardWidgetID}
									data-grid={{ x: widget.xs, y: widget.sm, w: widget.lg, h: widget.xl, static: !customLayout }}>

									<DashboardWidget
										key={widget.dashboardWidgetID}
										dashboardWidget={widget}
										filters={this.state.filters}
										changeDashboard={this.changeDashboard}
										localFilter={this.state.localFilter}
										changeLocalFilter={this.changeLocalFilter}
										removeBorders={removeBorders}
										setResizeCallBack={setResizeCallBack} />

								</div>
							);
						});
				}
				else
					return null;

			case 'loading':
				return <Grid item xl={12} lg={12} sm={12} xs={12}><Loader /></Grid>

			default:
				return <div>status no definido, revisar...</div>
		}
	}

	renderSortedWidgets() {
		const { selectedDashboard } = this.state;

		let sortedWidgets = [];
		if (!!selectedDashboard)
			sortedWidgets = selectedDashboard.dashboardWidgets.filter(f => { return f.sort > 0; });

		return this.renderWidgets(sortedWidgets);
	}

	renderUnsortedWidget() {
		const { selectedDashboard } = this.state;

		let unsortedWidgets = [];
		if (!!selectedDashboard)
			unsortedWidgets = selectedDashboard.dashboardWidgets.filter(f => { return f.sort <= 0; });

		return this.renderWidgets(unsortedWidgets, true);
	}

	changeDashboard = (dashboardKey) => {
		document.getElementsByClassName("db-body")[0].scroll(0, 0);
		const breadcrumb = !!dashboardKey ?
			[
				{ type: 'link', text: this.props.intl.formatMessage({ id: 'fleet', defaultMessage: 'Fleet' }), to: '/dashboard' },
				{ type: 'selector', to: `/dashboard/${dashboardKey}` }
			]
			:
			[
				{ type: 'link', text: this.props.intl.formatMessage({ id: 'fleet', defaultMessage: 'Fleet' }), to: '/dashboard' },
				{ type: 'selector', to: `/dashboard` }
			]

		this.context.setBreadCrumb(breadcrumb);

		const dashboard = this.state.dashboards.data.find(element => {
			return element.dashboardKey === dashboardKey;
		});

		if (!!dashboard)
			this.setState({ selectedDashboard: dashboard, localFilter: [] });
	}

	changeLocalFilter = (sort, filterID, filterValue) => {
		let localFilters = this.state.localFilter;
		let isAdded = false;

		if (Array.isArray(filterID)) { //Si es un arreglo de filtros
			localFilters = this.state.localFilter.filter(f => f.sort !== sort);
			for (let i = 0; i < filterID.length; i++) { //Recorrer filtros en parametros
				//Filtro a aplicar
				let lf = { sort, filterID: filterID[i], filterValue: filterValue[i] };
				localFilters.push(lf);
			}
		}
		else { //Cuando es un filtro unico
			//Filtro a aplicar
			const localFilter = { sort, filterID, filterValue };
			//Recorrer filtros existentes
			for (let i = 0; i < localFilters.length; i++) {
				//Si ya existe el filtro, actualizar
				if (localFilters[i].sort === localFilter.sort && localFilters[i].filterID === localFilter.filterID) {
					localFilters[i] = localFilter;
					isAdded = true;
				}
			}
			//Agregar filtro
			if (!isAdded)
				localFilters.push(localFilter);
		}

		this.setState({ localFilter: localFilters.filter(f => f.filterValue != null) }, () => { });
	}

	getDashboards = (pageSize, pageIndex) => {
		this.setState({ status: 'loading' });

		let locale = localStorage.getItem('locale');
		if (!locale) locale = 'en-US';

		hubAPI.get(`api/v1/Dashboard?pageSize=${pageSize}&pageIndex=${pageIndex}&culture=${locale}`)
			.then(response => {
				window["valuess"] = response.data;
				let selectedDashboard = response.data.data.length > 0 ? response.data.data[0] : null

				let params = (new URL(document.location)).searchParams;
				let urldashboardKey = params.get('dashboardKey');

				if (!!this.state.selectedComponentKey)
					urldashboardKey = this.state.selectedComponentKey;

				if (!!this.props.dashboardKey)
					selectedDashboard = response.data.data.find(f => f.dashboardKey === this.props.dashboardKey);

				else if (!!urldashboardKey && urldashboardKey !== '') {
					selectedDashboard = response.data.data.find(f => f.dashboardKey === urldashboardKey);
				}

				localStorage.removeItem('originalLayout');
				this.setState({
					dashboards: response.data,
					selectedDashboard: !!selectedDashboard ? selectedDashboard : null,
					status: 'ready'
				});
			})
			.catch(error => {
				if (error.response) {
					switch (error.response.status) {
						case 400:
						case 401:
						case 403:
							this.setState({ deniedView: true, status: 'ready' });
							break;

						default:
							this.setState({ requestError: true, status: 'ready' });
							console.log(error.response)
							break;
					}

				} else if (error.request) {
					this.setState({ requestError: true, status: 'ready' });
					console.log(error.request);
				}
				else
					this.setState({ requestError: true, status: 'ready' });

				console.log(error);
			});
	}

	getFilters = () => {
		if (this.state.companyID <= 0) {
			this.setState({ filters: [] }, () => { });
			return;
		}

		this.setState({ status: 'loading' });
		let locale = localStorage.getItem('locale');
		if (!locale) locale = 'en-US';

		hubAPI.get(`api/v1/Dashboard/filters/${this.state.companyID}?culture=${locale}`)
			.then(response => {
				this.setState({ filters: response.data }, () => { this.getDashboards(0, 0); });
			})
			.catch(error => {
				if (error.response) {
					switch (error.response.status) {
						case 400:
						case 401:
						case 403:
							this.setState({ deniedView: true, status: 'ready' });
							break;

						default:
							this.setState({ requestError: true, status: 'ready' });
							console.log(error.response)
							break;
					}

				} else if (error.request) {
					this.setState({ requestError: true, status: 'ready' });
					console.log(error.request);
				}
				else
					this.setState({ requestError: true, status: 'ready' });

				console.log(error);
			});
	}

	onResizeStop = (item, items) => {
		if (!!this.state.resizeCallBack[`widget${item.i}`]) {
			for (let x = 0; x < items.length; x++)
				if (items[x].i === item.i) {
					this.state.resizeCallBack[`widget${item.i}`](items[x]);
					this.updateLayout([items[x]]);
				}
		}
	}

	onLayoutChange(layout, layouts) {
		const originalLayout = localStorage.getItem('originalLayout');
		if (!originalLayout)
			localStorage.setItem('originalLayout', JSON.stringify(layouts));

		this.setState({ sortedLayout: layouts }, () => { });
	}

	restoreOriginalLayOut = () => {
		const { selectedDashboard } = this.state;

		hubAPI.delete(`api/v1/Dashboard/${selectedDashboard.dashboardID}/widgetlayout`)
			.then(response => { this.getDashboards(0, 0, true); })
			.catch(error => { console.log(error); });
	}

	updateLayout = (items) => {
		const { selectedDashboard, customLayout } = this.state;
		if (!customLayout) return;

		const layouts = items.map(x => {
			return {
				userID: '*',
				dashboardWidgetID: parseInt(x.i),
				x: x.x,
				y: x.y,
				w: x.w,
				h: x.h
			};
		});
		hubAPI.post(`api/v1/Dashboard/${selectedDashboard.dashboardID}/widgetlayout`, layouts)
			.then(response => { console.log(response); })
			.catch(error => { console.log(error); });
	}

	render() {
		const { children, title, classes } = this.props;
		const { selectedDashboard } = this.state;
		const { company } = this.context;

		const noAuthorization = this.state.deniedView ? <NoAuthorization /> : null;
		const noSuccess = this.state.requestError ? <NoSuccess /> : null;
		
		//Powerbi dashboard
		if (!!selectedDashboard && selectedDashboard.dashboardTypeID === 3) {
			return (
				<DashboardLayout title={!!title ? title : 'Dashboard'} grid="true" isDraggable={false} isResizable={false}>
					<Suspense fallback={<div>Loading...</div>}>
						<Slide className={classes.slide}>{noAuthorization}</Slide>
						<Slide className={classes.slide}>{noSuccess}</Slide>
						

						<DashboardPowerbi dashboard={selectedDashboard} ></DashboardPowerbi>
					</Suspense>
				</DashboardLayout>
			)
		}

		return (
			<DashboardLayout title={!!title ? title : 'Dashboard'} grid="true">
				<Suspense fallback={<div>Loading...</div>}>
					{!!company && company.companyStatusID === 3 && <Denied message={this.props.intl.formatMessage({ id: 'accountLockMessage', defaultMessage: 'Your account has been blocked because of payment issues' })} />}

					<Grid container spacing={1}>
						<Grid item xs={12} sm={12} lg={12} xl={12}>
							<Slide className={classes.slide}>{noAuthorization}</Slide>
							<Slide className={classes.slide}>{noSuccess}</Slide>
						</Grid>

						<Grid item xs={12} sm={12} lg={12} xl={12}>
							<div style={{ width: 'calc(100% - 15px)' }}>
								<ResponsiveReactGridLayout className="layout" rowHeight={68}
									breakpoints={{ lg: 1200, md: 992, sm: 768, xs: 576, xxs: 0 }}
									cols={{ lg: 12, md: 12, sm: 8, xs: 1, xxs: 1 }}
									compactType={null}>

									{this.renderUnsortedWidget()}
								</ResponsiveReactGridLayout>
							</div>

						</Grid>

						{
							this.state.showNonCompanyScheduleAlert && <Grid item xs={12} sm={12} lg={12} xl={12}>
								<NonCompanyScheduleMessage />
							</Grid>
						}

						<AlertsResume showFilter={false} />

						<Grid item xs={12} sm={12} lg={12} xl={12}>
							<div style={{ width: 'calc(100% - 15px)' }}>
								<ResponsiveReactGridLayout
									{...this.props}
									breakpoints={{ lg: 1200, md: 992, sm: 768, xs: 576, xxs: 0 }}
									compactType={null}
									onResizeStop={(items, item) => this.onResizeStop(item, items)}
									onDragStop={this.updateLayout}
									layouts={this.state.sortedLayout}

									onLayoutChange={(layout, layouts) => this.onLayoutChange(layout, layouts)} >

									{this.renderSortedWidgets()}

								</ResponsiveReactGridLayout>
							</div>
						</Grid>

						{children}
					</Grid>
				</Suspense>
			</DashboardLayout>
		);
	}
}

Dashboard.contextType = HUBContext;
Dashboard.propTypes = { classes: PropTypes.object.isRequired };
export default withStyles(styles)(injectIntl(Dashboard));